<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: BtnLinkName
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=8144-123320&t=Q08xSIR99kih0t0I-4
 */
import type { BtnLinkNameProps } from '../types/interfaces'

import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'
import { IconContainer } from '@shared/ui/other'

import { useBtnLinkName } from '../composables/use-btn-link-name.hook'

defineOptions({
  name: 'BtnLinkName',
})

const props = withDefaults(defineProps<BtnLinkNameProps>(), {
  linkName: '',
  disabled: false,
  tooltipText: 'Open link on new tab',
  target: '_blank',
})

const { refIsTooltipShown } = useBtnLinkName({ props })
</script>

<template>
  <div :class="['btn-link-name', { disabled }]">
    <AppTooltip
      v-if="linkUrl && refIsTooltipShown"
      :text="tooltipText"
    >
      <a
        class="btn-link-name__link"
        :target="target"
        :href="linkUrl"
      >
        <IconContainer>
          <slot name="iconLeft">
            <FontAwesomeIcon :icon="faArrowUpRightFromSquare" />
          </slot>
        </IconContainer>
        <AppText
          v-if="linkName"
          name="body1"
        >
          {{ linkName }}
        </AppText>
      </a>
    </AppTooltip>
    <a
      v-else-if="linkUrl"
      class="btn-link-name__link"
      :target="target"
      :href="linkUrl"
    >
      <IconContainer>
        <slot name="iconLeft">
          <FontAwesomeIcon :icon="faArrowUpRightFromSquare" />
        </slot>
      </IconContainer>
      <AppText
        v-if="linkName"
        name="body1"
      >
        {{ linkName }}
      </AppText>
    </a>
    <div
      v-else
      class="btn-link-name__text"
    >
      <IconContainer>
        <slot name="iconLeft">
          <FontAwesomeIcon :icon="faArrowUpRightFromSquare" />
        </slot>
      </IconContainer>
      <AppText
        v-if="linkName"
        name="body1"
      >
        {{ linkName }}
      </AppText>
      -
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_btn-link-name.scss" />
